import { Component, effect, EventEmitter, input, Input, OnInit, Output } from '@angular/core';
import { SidebarListItem } from 'src/app/shared/components/ui/sidebar/sidebar.component';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { AsyncPipe, NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { WorkspaceItemType } from 'src/models/ts/workspace-item-type.model';
import { Observable } from 'rxjs';
import { WorkspaceSidebarItemDto } from 'src/models/ts/workspace-sidebar-item-dto.model';

@Component({
  selector: 'bizz-sidebar-link',
  standalone: true,
  imports: [
    IconComponent,
    NgClass,
    RouterLink,
    AsyncPipe,
    RouterLinkActive
  ],
  templateUrl: './sidebar-link.component.html',
  styleUrl: './sidebar-link.component.scss'
})
export class SidebarLinkComponent {

  public link : string;
  protected static WorkspaceItemType = WorkspaceItemType;

  @Input() public isMobile: boolean;
  @Input() public newTableViewRecordLinkActive: boolean;
  public sidebarListItem = input<SidebarListItem>();
  @Input() public workspaceSidebarItem : WorkspaceSidebarItemDto;
  @Input() public expanded: Observable<boolean>;
  @Input() public workspaceId: number;
  @Input() public isChild: boolean = false;
  @Output() public sidebarLinkClicked = new EventEmitter<void>();
  public setSidebarListItem: SidebarListItem | undefined;

  private changedSidebarLink = effect(() => {
    this.setSidebarListItem = this.sidebarListItem();
    if (this.setSidebarListItem  == undefined || this.workspaceSidebarItem != undefined) {
      this.setSidebarListItem = this.workspaceSidebarItem as SidebarListItem;
    }
    this.setLink();
  });

  private setLink():void {
    if(this.setSidebarListItem){
      switch (this.setSidebarListItem.ItemType) {
        case WorkspaceItemType.Widget:
          this.link = '/workspace/' + this.workspaceId + '/widget/' + this.setSidebarListItem.WorkspaceItemsID;
          break;
        case WorkspaceItemType.NewTableViewRecord:
          this.link = 'form/collectionsid/' + this.setSidebarListItem?.CollectionsID + '/workspaceitemsid/' + this.setSidebarListItem.WorkspaceItemsID;
          break;
        case WorkspaceItemType.Dashboard:
          this.link = '/workspace/' + this.workspaceId + '/dashboard/' + this.setSidebarListItem.WorkspaceItemsID;
          break;
        default:
          break;
      }
    }
  }
}
